module.exports = __webpack_public_path__ + "img/icon_failure_to_pay@2x.2744208e.png";